import { isDate as isDate$1 } from "../../predicate/isDate.mjs";
//#region src/compat/predicate/isDate.ts
/**
* Checks if `value` is a Date object.
*
* @param {any} value The value to check.
* @returns {value is Date} Returns `true` if `value` is a Date object, `false` otherwise.
*
* @example
* const value1 = new Date();
* const value2 = '2024-01-01';
*
* console.log(isDate(value1)); // true
* console.log(isDate(value2)); // false
*/
function isDate(value) {
	return isDate$1(value);
}
//#endregion
export { isDate };
